<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Merge Profile Modal"
    seFeDataSubtitle="Display modal to merge two profiles together"
    size="750">
  </se-fe-header>

  <div seFePageContent>
    <se-fe-card class="docs-card">
      <se-fe-card-header
        seFeDataTitle="When to use"
      ></se-fe-card-header>
      <se-fe-card-content>
        <p>Use in MySe Households or in other places where we merge duplicate profiles</p>
      </se-fe-card-content>
    </se-fe-card>

    @for (n of models; track n) {
      <se-fe-card class="docs-card">
        <se-fe-card-header [seFeDataTitle]="n"></se-fe-card-header>
        <se-fe-card-content>
          <se-fe-docs-table
            [seFeDataHeaders]="headers[n]"
            [seFeDataRows]="rows[n]">
          </se-fe-docs-table>
        </se-fe-card-content>
      </se-fe-card>
    }

    <se-fe-card class="docs-card">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-merge-persona-modal-example></se-po-merge-persona-modal-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
